import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gisAttribute'
})
export class GisAttributePipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      let name = it.attribute_name;
      return name.toLowerCase().includes(searchText);
    });
  }
}
